import gql from "graphql-tag";

export default gql`
  query getBloombergCatalog {
    getBloombergCatalog {
      version
      mode
      storage_enabled
      execution_enabled
      coverage_available
      profile_id
      dataset
      max_identifiers
      max_backfill_days
      categories {
        id
        label
        description
        fields {
          mnemonic
          data_type
          history_status
          description
        }
      }
      schedules {
        id
        label
        timezone
        description
      }
      blockers
    }
  }
`;